import { Trash2 } from "lucide-react";
import { PaymentCard } from "@/features/payment/types";
import { CardView } from "@/features/payment/components/CardView";
import { ActionMenu } from "@clarityos/ui/action-menu";
import type { ActionMenuItem } from "@clarityos/ui/action-menu";
import useDisclosure from "@/hooks/useDsiclosure";
import DeletePatientCardConfirmation from "../DeletePatientCardConfirmation";
import { Card } from "@clarityos/ui";

interface CardOnFileRowProps {
  card: PaymentCard;
  patientFullName: string;
  patientId: string;
  practiceId: string;
}

export function CardOnFileRow({
  card,
  patientId,
  practiceId,
  patientFullName,
}: CardOnFileRowProps) {
  const deleteCardDisclosure = useDisclosure();

  return (
    <>
      <Card
        header={
          <div className="flex items-center gap-3.5">
            <CardView card={card} fallbackName={patientFullName} />

            <ActionMenu
              triggerLabel={`Open card actions for ${patientFullName}`}
              items={[
                {
                  key: "delete",
                  label: "Delete Card",
                  icon: Trash2,
                  destructive: true,
                  onClick: deleteCardDisclosure.onOpen,
                  "data-testid": "delete-card-action",
                } as ActionMenuItem,
              ]}
            />
          </div>
        }
      />
      <DeletePatientCardConfirmation
        cardOnFile={card}
        patientId={patientId}
        practiceId={practiceId}
        patientFullName={patientFullName}
        open={deleteCardDisclosure.open}
        onClose={deleteCardDisclosure.onClose}
      />
    </>
  );
}
